import { Component, ElementRef, OnInit, VERSION, ViewChild } from '@angular/core';
import * as S3 from 'aws-sdk/clients/s3';
import { Ads } from 'app/models/ads';
import * as _ from 'lodash';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { AdsService } from 'app/services/ads/ads.service';
import { NgForm } from '@angular/forms';
import { AwscontrolService } from 'app/services/aws/awscontrol.service'; // Import AWS service


@Component({
  selector: 'app-ajouter-ads',
  templateUrl: './ajouter-ads.component.html',
  styleUrls: ['./ajouter-ads.component.scss']
})
export class AjouterAdsComponent implements OnInit {
  myFilter1 = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  };
  myFilter2 = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== 0 && day !== 6;
  };
  @ViewChild('adsForm', { static: false })
  adsForm: NgForm;
  name = 'Angular ' + VERSION.major;
  dataimage: any;

  @ViewChild('fileInput') fileInput: ElementRef;
  fileAttr = 'Choose File';
  selectedFiles1: FileList;
  fileNames :any=[]
  photourl!: string
  allAttch:any[] =[];
  public image! : string

  adsData: Ads;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  isEditMode = false;

  public getRandomString(length:any) {

    var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }
  uploadimg2() {

    let i=0
    console.log(this.selectedFiles1)
    for (i=0; i<this.selectedFiles1.length;i++ ){
      const file = this.selectedFiles1[i];
      this.uploadFileimg2(file);
      
    }
    
    // console.log(file)
  }
  selectFileimg(e:any) {
    this.selectedFiles1 = e.target.files;
    
    this.uploadimg2();
  }
  async uploadFileimg2(file:any) {
    this.fileNames.push(file.name)
    const contentType = file.type;
    
    // Use AwscontrolService instead of direct S3
    const renamedFile = new File([file], `${this.getRandomString(5)}_${file.name}`, { type: contentType });
    
    this.awsService.uploadFile(renamedFile, 'ads-images').subscribe(
      (response) => {
        if (response.success && response.urls.length > 0) {
          const adsImg = response.urls[0];
          localStorage.setItem('adsImg',JSON.stringify(adsImg) )
          
          this.allAttch.push(adsImg)
          console.log(this.allAttch)
          this.image=adsImg;
        }
      },
      (err) => {
        console.log('There was an error uploading your file: ', err);
      }
    );
  }

  constructor(private adsService:AdsService, private awsService: AwscontrolService) {
    this.adsData = new Ads;
   }


getData(){
// Initializing Datatable pagination
this.dataSource.paginator = this.paginator;

// Fetch All Students on Page load
this.getAllAds()
}

  ngOnInit(): void {
    this.adsService.refreshNedeed.subscribe(() => this.getData());
    this.getData()
  }


  getAllAds() {
    this.adsService.getListAds().subscribe((response: any) => {
      this.dataSource.data = response;
    });
  }
  editItem(element) {
    this.adsData = _.cloneDeep(element);
    this.isEditMode = true;
  }

  cancelEdit() {
    this.isEditMode = false;
    this.adsForm.resetForm();
  }

  

  onSubmit() {
    this.adsService.createAds(this.adsData).subscribe((response: any) => {
      this.dataSource.data.push({ ...response })
      this.dataSource.data = this.dataSource.data.map(o => {
        return o;
      })
    });
    setTimeout(()=>{
      this.getData()
    },500)
  }
  updateAds() {
    this.adsService.updateAds(this.adsData.id, this.adsData).subscribe((response: any) => {

      this.dataSource.data = this.dataSource.data.map((o: Ads) => {
        if (o.id === response.id) {
          o = response;
        }
        return o;
      })

     

      this.cancelEdit()

    });
  }




  csvInputChange(fileInputEvent: any) {
    console.log(fileInputEvent.target.files[0]);
  }


}